module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "px-6 py-2 border rounded cursor-pointer bg-gray-100 text-gray-500",
    on: {
      "click": function($event) {
        return _vm.showAssessmentModal()
      }
    }
  }, [_vm._v("\n    View Criteria\n  ")]), _vm._v(" "), (_vm.isAssessmentModalOpen === true) ? _c('pl-dialog', {
    attrs: {
      "size": 'md'
    },
    on: {
      "close": function($event) {
        _vm.isAssessmentModalOpen = false
      }
    }
  }, [(_vm.criteriaScale > 0) ? _c('div', {
    staticClass: "pl-subheading start-xs"
  }, [_vm._v("\n      Max Score: " + _vm._s(_vm.criteriaScale) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row col-xs start-xs overflow-auto",
    staticStyle: {
      "padding": "10px 20px"
    }
  }, _vm._l((_vm.rewards), function(point, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-6 start-xs p-3"
    }, [_c('span', {
      staticClass: "pl-title"
    }, [_vm._v("\n          " + _vm._s(point.title) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "pl-body-2 row col-xs start-xs middle-xs"
    }, [_c('p', [_vm._v(_vm._s(typeof point.description === 'object' ? point.description.join('. ') : point.description))])])])
  }), 0)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-16081f6a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/pointDescriptions.vue
// module id = 1205
// module chunks = 61